import axios from "@/plugins/axios";

let url = "/api/console/contracts";

export default {
    getContracts(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    getContract(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    postContract(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    postContractDocument(data) {
        return axios.post(`${url}/${data._contract}/documents`, data).then((result) => result.data);
    },
    putContract(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    test(data) {
        return axios.put(`${url}/${data._id}/test`, data).then((result) => result.data);
    },
    deleteContract(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
    payments: {
        post(data) {
            return axios.post(`${url}/${data._contract}/payments`, data).then((result) => result.data);
        },
        put(data) {
            return axios.put(`${url}/${data._contract}/payments/${data._payment}`, data).then((result) => result.data);
        },
        delete(data) {
            return axios.delete(`${url}/${data._contract}/payments/${data._payment}`, data).then((result) => result.data);
        },
    },
    taxProof: {
        post(data) {
            return axios.post(`${url}/${data._contract}/payments/${data._payment}/taxProof`, data).then((result) => result.data);
        },
    },
    settlement: {
        post(data) {
            return axios.post(`${url}/${data._contract}/payments/${data._payment}/settlement`, data).then((result) => result.data);
        },
    },
};
